import React from 'react';
import Icone, { NomeIcone } from '../primitivos/Icone';

/**
 * Estado vazio de uma lista (at-56, frente B).
 *
 * 🔴 **"Não há nada" e "a busca não achou nada" são coisas diferentes**, e a spec
 * 02 §2.7 pede a distinção explicitamente (hoje as duas mostram o mesmo texto
 * "Nenhum associado encontrado"). Elas exigem ações opostas do usuário: uma pede
 * para começar um cadastro, a outra para mudar o termo. Este componente não
 * adivinha qual é o caso — quem consome passa os textos —, mas **é obrigação de
 * quem consome passar textos diferentes** nos dois.
 *
 * 📌 Na fila de trabalho da aba "Em andamento", vazio é BOA notícia (não há
 * trabalho parado) e o texto deve dizer isso (spec 02 §3.8). Estado vazio não é
 * sempre uma falta.
 */

interface PropsEmptyState {
  titulo: string;
  descricao?: string;
  /** Padrão `sem-dados`. */
  icone?: NomeIcone;
  /** Ação que resolve o vazio (ex.: "Nova Adesão"). Opcional. */
  acao?: React.ReactNode;
}

const EmptyState: React.FC<PropsEmptyState> = ({
  titulo,
  descricao,
  icone = 'sem-dados',
  acao,
}) => (
  /* Medidas do protótipo: `py-16` e borda tracejada mais marcada que a das
     superfícies (#CFD6D1), senão o tracejado desaparece sobre o branco. */
  <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-dashed tw-border-texto-desabilitado/50 tw-bg-white tw-px-6 tw-py-16 tw-text-center">
    <span className="tw-text-texto-desabilitado" aria-hidden="true">
      <Icone nome={icone} tamanho={36} traco={1.5} />
    </span>
    <p className="tw-m-0 tw-font-marca tw-text-base tw-font-bold tw-text-texto-corpo">{titulo}</p>
    {descricao && <p className="tw-m-0 tw-text-sm tw-text-texto-suave">{descricao}</p>}
    {acao && <div className="tw-mt-2">{acao}</div>}
  </div>
);

export default EmptyState;
